import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { HowWeWork } from "@/components/site/HowWeWork";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { QuoteEstimator } from "@/components/site/QuoteEstimator";
import { Academy } from "@/components/site/Academy";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#050505] text-white font-body antialiased overflow-x-hidden">
        <Header />
        <main>
          <Hero />
          <Services />
          <About />
          <Gallery />
          <WhyChooseUs />
          <HowWeWork />
          <Testimonials />
          <FAQ />
          <QuoteEstimator />
          <Academy />
          <Contact />
        </main>
        <Footer />
        <FloatingButtons />
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
